import { render, staticRenderFns } from "./DeliveryRequestUpdateModal.vue?vue&type=template&id=50810f31"
import script from "./DeliveryRequestUpdateModal.vue?vue&type=script&lang=js"
export * from "./DeliveryRequestUpdateModal.vue?vue&type=script&lang=js"
import style0 from "./DeliveryRequestUpdateModal.vue?vue&type=style&index=0&id=50810f31&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports